module.exports = __webpack_public_path__ + "img/staple_tee.bf45d6c6.jpg";